import type { UpdateMbcBriefBody } from "@nlc/shared-types";

import { MBC_MASTRA_API_URL } from "../config/mbc-chat.config";

// Saves for one thread are sent one after another so add/remove of the same
// item can't land out of order.
const inFlight = new Map<string, Promise<unknown>>();

/**
 * Persist a partial brief edit (live save). Reuses the review page's PATCH
 * route: text and list fields are replaced; assets and inspirations change
 * only through `assetChanges` deltas, which the server applies to the stored
 * groups.
 */
export function patchBrief(
  threadId: string,
  resourceId: string | undefined,
  patch: UpdateMbcBriefBody,
): Promise<void> {
  const previous = inFlight.get(threadId) ?? Promise.resolve();
  const next = previous
    .catch(() => {})
    .then(() => sendPatch(threadId, resourceId, patch));

  inFlight.set(threadId, next);

  return next;
}

async function sendPatch(
  threadId: string,
  resourceId: string | undefined,
  patch: UpdateMbcBriefBody,
): Promise<void> {
  const query = resourceId
    ? `?resourceId=${encodeURIComponent(resourceId)}`
    : "";

  const response = await fetch(
    `${MBC_MASTRA_API_URL}/mbc/brief/${encodeURIComponent(threadId)}${query}`,
    {
      body: JSON.stringify(patch),
      headers: { "Content-Type": "application/json" },
      method: "PATCH",
    },
  );

  if (!response.ok) throw new Error(`HTTP ${response.status}`);
}
